import { useState, useEffect } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import InputMask from "react-input-mask";

import Dates from "../date/Dates";
import Fieldset from "./Fieldset";

export default function GeneralQuestions({ applyBeforeLabel, only2, product, state, onChange }) {
  const [numberOfAgricultureEmployees, setNumberOfAgricultureEmployees] = useState(state.numberOfAgricultureEmployees);
  const [numberOfHouseholdeEmployees, setNumberOfHouseholdeEmployees] = useState(state.numberOfHouseholdeEmployees);
  const [numberOfOtherEmployees, setNumberOfOtherEmployees] = useState(state.numberOfOtherEmployees);

  useEffect(() => {
    setNumberOfAgricultureEmployees(state.numberOfAgricultureEmployees);
    setNumberOfHouseholdeEmployees(state.numberOfHouseholdeEmployees);
    setNumberOfOtherEmployees(state.numberOfOtherEmployees);
  }, [state]);

  function handleNumberOfAgricultureEmployees(event) {
    setNumberOfAgricultureEmployees(event.target.value);
    onChange(event);
  }

  function handleNumberOfHouseholdeEmployees(event) {
    setNumberOfHouseholdeEmployees(event.target.value);
    onChange(event);
  }

  function handleNumberOfOtherEmployees(event) {
    setNumberOfOtherEmployees(event.target.value);
    onChange(event);
  }

  return (
    <>
      <div className="radio">
        <h5>General questions</h5>
        {["EIN_SoleProp", "EIN_LLC", "EIN_CCorp", "EIN_SCorp"].includes(product?.code) && (
          <>
            <Fieldset
              id="acceptCreditCardPayments"
              label="Does your business plan to or currently accept Credit Card payments?"
              questionValue={state.acceptCreditCardPayments}
              value={state.acceptCreditCardPayments}
              onChange={onChange}
            />
            <Fieldset
              id="payEmployeesViaPayroll"
              label="Does your business plan to pay employees via payroll?"
              questionValue={state.payEmployeesViaPayroll}
              value={state.payEmployeesViaPayroll}
              onChange={onChange}
            />
          </>
        )}
        {!only2 ? (
          <>
            <Fieldset
              id="questionsHighway"
              label="Does your business own a highway motor vehicle weighing 55,000 pounds or
                                    more?"
              tooltip
              tooltipHeader={
                "Does your business own a highway motor vehicle weighing 55,000 pounds or\n" +
                "                                    more?"
              }
              tooltipText={
                <>
                  Please select yes if this applies to your business.
                  <br />
                  <strong>The most common answer to this question is No.</strong>
                </>
              }
              questionValue={state.questionsHighway}
              value={state.questionsHighway}
              onChange={onChange}
            />
            <Fieldset
              id="questionsGambling"
              label="Does your business involve gambling?"
              tooltip
              tooltipHeader="Does your business involve gambling?"
              tooltipText={
                <>
                  Please select yes if this applies to your business.
                  <br />
                  <strong>The most common answer to this question is No.</strong>
                </>
              }
              questionValue={state.questionsGambling}
              value={state.questionsGambling}
              onChange={onChange}
            />
            <Fieldset
              id="questionsATF"
              label="Does your business sell or manufacture alcohol, tobacco, or firearms?"
              tooltip
              tooltipHeader="Does your business sell or manufacture alcohol, tobacco, or firearms?"
              tooltipText={
                <>
                  Please select yes if this applies to your business.
                  <br />
                  <strong>The most common answer to this question is No.</strong>
                </>
              }
              questionValue={state.questionsATF}
              value={state.questionsATF}
              onChange={onChange}
            />
            <Fieldset
              id="questionsExcise"
              label="Does your business pay federal excise taxes?"
              tooltip
              tooltipHeader="Does your business pay federal excise taxes?"
              tooltipText={
                <>
                  Please select yes if this applies to your business.
                  <br />
                  <strong>The most common answer to this question is No.</strong>
                </>
              }
              questionValue={state.questionsExcise}
              value={state.questionsExcise}
              onChange={onChange}
            />
          </>
        ) : null}
        <Fieldset
          id="questionsAppliedBefore"
          label={applyBeforeLabel ? applyBeforeLabel : "Has this LLC ever received or applied for an EIN before?"}
          tooltip
          tooltipHeader={
            applyBeforeLabel ? applyBeforeLabel : "Has this LLC ever received or applied for an EIN before?"
          }
          tooltipText={
            <>
              Please select yes if this applies to your business.
              <br />
              <strong>
                The most common answer to this question is No. If you select yes, provide details in the fields that
                will appear below.
              </strong>
            </>
          }
          questionValue={state.questionsAppliedBefore}
          value={state.questionsAppliedBefore}
          onChange={onChange}
        />
      </div>
      {state.questionsAppliedBefore === "false" ? null : (
        <>
          <Form.Group controlId="previousEINNumberFirst2">
            <Form.Label>Previous EIN number, first 2 digits</Form.Label>
            <InputMask mask="99" maskChar={null} value={state.previousEINNumberFirst2} onChange={onChange}>
              {(inputProps) => <Form.Control required data-hj-allow type="text" placeholder="XX" pattern=".{2,}" />}
            </InputMask>
            <Form.Control.Feedback type="invalid">Please specify the previous EIN</Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="previousEINNumberLast7">
            <Form.Label>Previous EIN number, last 7 digits</Form.Label>
            <InputMask mask="9999999" maskChar={null} value={state.previousEINNumberLast7} onChange={onChange}>
              {(inputProps) => (
                <Form.Control required data-hj-allow type="text" placeholder="XXXXXXX" pattern=".{7,}" />
              )}
            </InputMask>
            <Form.Control.Feedback type="invalid">Please specify the previous EIN</Form.Control.Feedback>
          </Form.Group>
        </>
      )}
      <div className="radio">
        <Fieldset
          id="questionsHire"
          label="Do you currently have, or plan to hire employees within the next year (not including
                                    owners)?"
          tooltip
          tooltipHeader={
            "Do you currently have, or plan to hire employees within the next year (not including owners)?"
          }
          tooltipText={
            <>
              Please select yes if this applies to your business.
              <br />
              <strong>
                The most common answer to this question is No. If you select yes, provide details in the fields that
                will appear below.
              </strong>
            </>
          }
          questionValue={state.questionsHire}
          onChange={onChange}
        />
      </div>
      {state.questionsHire === "false" ? null : (
        <>
          <div className="radio">
            <Fieldset
              id="payLessThan4k"
              label="Do you expect your employment tax liability to be $1,000 or less in a full calendar year? (January-December)?"
              tooltip
              tooltipHeader={
                "Do you have, or do you expect to have, any employees who will receive Forms W-2 in the next 12 months? \n" +
                "Employees who will Receive Forms W-2"
              }
              tooltipText={
                <>
                  A Form W-2 (Wage and Tax Statement) is issued by an employer to his or her employees showing taxes
                  deducted from their yearly pay. Taxes covered on the W-2 are: federal income tax, Social Security tax
                  and Medicare tax.
                </>
              }
              questionValue={state.payLessThan4k}
              value={state.payLessThan4k}
              onChange={onChange}
            />
            {state.payLessThan4k === "true" ? (
              <Fieldset
                id="annualTaxes"
                label="Do you want to file employment tax annually instead of quarterly?"
                questionValue={state.annualTaxes}
                value={state.annualTaxes}
                onChange={onChange}
              />
            ) : null}
          </div>
          <OverlayTrigger
            rootClose
            placement="right-start"
            overlay={
              <Tooltip
                id="overlay-example"
                className="helpTooltip"
                style={{ fontSize: "16px", fontFamily: "Source Sans Pro" }}
              >
                <strong>Number of OR expected number of Agricultural Employees</strong>
                <br />
                Agricultural employees include any person who works on a farm producing crops and/or raising livestock.
                Farms include stock, dairy, poultry, fruit, fur-bearing animal, and truck farms, as well as orchards,
                plantations, ranches, nurseries, ranges, green houses, and other similar structures used mainly for
                raising agricultural or horticultural commodities.
                <br />
                Forestry and lumbering are not &quot;farm work&quot; unless the products are for use in the employer&apos;s farming
                operations.
                <br />
                Farm workers or agricultural employees include those who:
                <br />
                <ul style={{ fontSize: "16px" }}>
                  <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro" }}>
                    Raise or harvest agricultural or horticultural products, or care for the farm and equipment
                  </li>
                  <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro" }}>
                    Handle, process, or package any agricultural or horticultural commodity, if over half is produced on
                    the farm
                  </li>
                  <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro" }}>
                    {" "}
                    Do work related to cotton ginning, turpentine, or gum resin products
                  </li>
                  <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro" }}>
                    Do housework in the private home of a farm operated for profit.
                  </li>
                </ul>
              </Tooltip>
            }
          >
            <Form.Group controlId="numberOfAgricultureEmployees">
              <Form.Label>Number of Agricultural Employees</Form.Label>
              <Form.Control
                required
                data-hj-allow
                type="text"
                pattern="[0-9]*"
                isInvalid={numberOfHouseholdeEmployees + numberOfAgricultureEmployees + numberOfOtherEmployees < 1}
                defaultValue={state.numberOfAgricultureEmployees}
                value={state.numberOfAgricultureEmployees}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onChange={handleNumberOfAgricultureEmployees}
              />
            </Form.Group>
          </OverlayTrigger>
          {product && (product.code === "EIN_Partnership" || product.code === "EIN_PSC") ? null : (
            <Form.Group controlId="numberOfHouseholdeEmployees">
              <Form.Label>Number of Household Employees</Form.Label>
              <Form.Control
                required
                data-hj-allow
                type="text"
                pattern="[0-9]*"
                isInvalid={numberOfHouseholdeEmployees + numberOfAgricultureEmployees + numberOfOtherEmployees < 1}
                value={state.numberOfHouseholdeEmployees}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) event.preventDefault();
                }}
                onChange={handleNumberOfHouseholdeEmployees}
              />
            </Form.Group>
          )}
          <OverlayTrigger
            rootClose
            placement="right-start"
            overlay={
              <Tooltip
                id="overlay-example"
                className="helpTooltip"
                style={{ fontSize: "16px", fontFamily: "Source Sans Pro" }}
              >
                <strong>Number of OR expected number of Other Employees</strong>
                <br />
                A general rule is that anyone who performs services for you is your employee if you can control what
                work will be done and how it will be done. These employees will be issued a W-2 form at the end of the
                year.
                <br />
                Employers must file Form W-2 for wages paid to each employee from whom:
                <br />
                Income, Social Security, or Medicare tax was withheld or Income tax would have been withheld if the
                employee had claimed no more than one withholding allowance or had not claimed exemption from
                withholding on Form W-4 (Employee&apos;s Withholding Allowance Certificate).
                <br />
                Note: Total number of employees must be at least 1.
              </Tooltip>
            }
          >
            <Form.Group controlId="numberOfOtherEmployees">
              <Form.Label>Number of Other Employees</Form.Label>
              <Form.Control
                required
                data-hj-allow
                type="text"
                pattern="[0-9]*"
                isInvalid={numberOfHouseholdeEmployees + numberOfAgricultureEmployees + numberOfOtherEmployees < 1}
                value={state.numberOfOtherEmployees}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) event.preventDefault()
                }}
                onChange={handleNumberOfOtherEmployees}
              />
              <Form.Control.Feedback type="invalid">
                Please specify a number. Total number of employees must be at least 1.
              </Form.Control.Feedback>
            </Form.Group>
          </OverlayTrigger>
          <Dates
            id="firstDateWages"
            label="First date wages or annuities were or will be paid"
            tooltip={false}
            month={state.firstDateWagesMonth}
            day={state.firstDateWagesDay}
            year={state.firstDateWagesYear}
            isValid={state.firstDateWagesIsValid}
            onChange={onChange}
          />
        </>
      )}
    </>
  );
}
